/**
 * Type of modal to show
 */
export default {
  CREATE_PERSONAL_PROFILE_TYPE: 2,
  CREATE_MISSION_PROFILE_TYPE: 3,
  EDIT_PERSONAL_PROFILE_TYPE: 4,
  EDIT_MISSION_PROFILE_TYPE: 5,
  REMOVE_TYPE: 6,
  ADD_PERMISSIONS: 7,
  REMOVE_PERMISSIONS: 8,
}
